import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'
import { InstagramCommentTemplate } from './variants/InstagramComment'
import { InstagramSlideTemplate } from './variants/InstagramSlide'

const commentVariant = {
  ...productRowVariantForPath('instagram', 2),
  Template: InstagramCommentTemplate,
} as const satisfies RowVariantDefinition

const slideVariant = {
  ...productRowVariantForPath('instagram', 3),
  Template: InstagramSlideTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('instagram')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [commentVariant, slideVariant, sharedChatAnswerVariant],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [commentVariant, slideVariant],
    fallback: productRows.submsges.fallback,
  },
})
